import { SimpleInput, SimpleInputProps } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

type DateInputProps = Pick<
  SimpleInputProps,
  'onChange' | 'onBlur' | 'name' | 'label' | 'required' | 'errorMessage' | 'value'
>;

export const MonthDateInput = forwardRef<HTMLInputElement, DateInputProps>((props, ref) => (
  <SimpleInput ref={ref} size="sm" type="month" {...props} />
));
